import { GlobalOutlined, MailOutlined, ReadOutlined } from '@ant-design/icons';
import { ContactSupport } from '@styled-icons/material-rounded';
import { Dropdown, Menu } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getI18n } from 'react-i18next';

import LocaleChanger from '@/components/LocaleChanger';
import Tour from '@/components/Tour';
import useUser from '@/hooks/useUser';

import { DropdownNav } from './index.styled';
export default function Support(): React.ReactElement {
  const { t } = useTranslation();
  const i18n = getI18n();
  const user = useUser();
  const isLandlord = user?.activeClient.type === 'landlord';
  const [localeChangerVisible, setLocaleChangerVisible] = useState(false);
  const [tutorialVisible, setTutorialVisible] = useState(false);
  const handleMenuClick = ({ key }): void => {
    if (key === 'localeChanger') {
      !localeChangerVisible && setLocaleChangerVisible(true);
    }
    if (key === 'tutorial') {
      !tutorialVisible && setTutorialVisible(true);
    }
  };

  const menu = [
    {
      key: 'localeChanger',
      icon: <GlobalOutlined style={{ fontSize: '12px' }} />,
      label: i18n.language === 'sv' ? 'Svenska' : 'English',
    },
    {
      key: 'tutorial',
      icon: <ReadOutlined />,
      label: t('Tutorial'),
    },
    {
      key: 'contact',
      icon: <MailOutlined />,
      component: (
        <a href={'mailto:support@portally.com'} style={{ color: 'inherit' }}>
          {t('Contact us presents')}
        </a>
      ),
    },
  ];

  return (
    <>
      <LocaleChanger
        visible={localeChangerVisible}
        setVisible={setLocaleChangerVisible}
      />
      <Tour
        visible={tutorialVisible}
        setVisible={setTutorialVisible}
        name={isLandlord ? 'landlord' : 'tenant'}
        key="landlord2"
      />
      <Dropdown
        menu={{
          items: menu.map(item => ({
            key: item.key,
            label: item.component || item.label,
            icon: item.icon,
            onClick: () => handleMenuClick({ key: item.key }),
          })),
        }}
        trigger={['click']}
        placement="topLeft"
        arrow
        align={{
          offset: [20, 11],
        }}
      >
        <button
          type="button"
          style={{
            fontSize: '11px',
            color: '#f0f0f0',
            padding: '10px 0',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            width: '100%',
            background: 'transparent',
            border: 'none',
          }}
          className="dropdown tour tour-support"
        >
          <ContactSupport
            style={{ width: '26px', height: '26px', marginBottom: '5px' }}
          />
          <span className="text" style={{ fontSize: '11px' }}>
            {t('Help')}
          </span>
        </button>
      </Dropdown>
    </>
  );
}
